export const blockchainMainItem = [
  { id: 1, title: "NFTs" },
  { id: 2, title: "Ethereum Virtual Machine (EVM)" },
  { id: 3, title: "Blockchain" },
  { id: 4, title: "Metaverse" },
  { id: 5, title: "Web 3.0" },
  { id: 6, title: "Crypto" },
  { id: 7, title: "DeFi" },
  { id: 8, title: "Generative AI" },
  { id: 9, title: "ICO/STO/IDO" },
  { id: 10, title: "Marketing" },
];

export const GenerativeAI1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/AI/AI Agent Development Company",
    href: "/ai/ai-agent-development-services",
    title: "AI Agent Development Company",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/AI/Generative AI Development Company",
    href: "/ai/generative-ai-development-services",
    title: "Generative AI Development Company",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/AI/Machine Learning Development Company",
    href: "/ai/machine-learning-development-services",
    title: "Machine Learning Development Company",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/AI/AI Chatbot Development Company",
    href: "/ai/ai-chatbot-development-services",
    title: "AI Chatbot Development Company",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/AI/Voice AI Agent System",
    href: "/ai/voice-ai-agent-system-services",
    title: "Voice AI Agent System Development Company",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/AI/On-chain AI Agent Marketplace",
    href: "/ai/on-chain-ai-agent-marketplace-services",
    title: "On-chain AI Agent Marketplace Development Company",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/AI/AI Workflow Development using n8n",
    href: "/ai/ai-workflow-development-n8n-services",
    title: "AI Workflow Development using n8n Development Company",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/AI/Custom AI Model Development",
    href: "/ai/custom-ai-model-development-services",
    title: "Custom AI Model Development Company",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/AI/AI Data Analytics & Insights",
    href: "/ai/ai-data-analytics-insights-services",
    title: "AI Data Analytics & Insights Development Company",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/AI/AI Automation Solutions",
    href: "/ai/ai-automation-solutions-services",
    title: "AI Automation Solutions Development Company",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/AI/Generative AI Solutions",
    href: "/ai/generative-ai-solutions-services",
    title: "Generative AI Solutions Development Company",
  },
  {
    id: 12,
    image: "/assets/Header/Blockchain/AI/AI SaaS Product Development",
    href: "/ai/ai-saas-product-development-services",
    title: "AI SaaS Product Development Company",
  },
  {
    id: 13,
    image: "/assets/Header/Blockchain/AI/AI Security and Fraud Detection",
    href: "/ai/ai-security-fraud-detection-services",
    title: "AI Security and Fraud Detection Development Company",
  },
  {
    id: 14,
    image: "/assets/Header/Blockchain/AI/AI Personalization Engines",
    href: "/ai/ai-personalization-engines-services",
    title: "AI Personalization Engines Development Company",
  },
  {
    id: 15,
    image: "/assets/Header/Blockchain/AI/AI API & Integration Services",
    href: "/ai/ai-api-integration-services",
    title: "AI API & Integration Services Development Company",
  },
  {
    id: 16,
    image: "/assets/Header/Blockchain/AI/AI Consulting & Strategy",
    href: "/ai/ai-consulting-strategy-services",
    title: "AI Consulting & Strategy Development Company",
  },
  {
    id: 17,
    image: "/assets/Header/Blockchain/AI/Multi-Agent Systems Development",
    href: "/ai/multi-agent-systems-development-services",
    title: "Multi-Agent Systems Development Company",
  },
  {
    id: 18,
    image: "/assets/Header/Blockchain/AI/On-Premise and Private AI Deployment",
    href: "/ai/on-premise-private-ai-deployment-services",
    title: "On-Premise and Private AI Development Company",
  },
];

export const GenerativeAI2 = [
  {
    id: 19,
    image: "/assets/Header/Blockchain/AI/AI-Powered CRM Systems",
    href: "/ai/ai-powered-crm-systems-services",
    title: "AI-Powered CRM Systems Development Company",
  },
  {
    id: 20,
    image: "/assets/Header/Blockchain/AI/nlp-process",
    href: "/ai/ai-document-processing-ocr-nlp-services",
    title: "AI Document Processing (OCR + NLP) Development Company",
  },
  {
    id: 21,
    image: "/assets/Header/Blockchain/AI/AI Recommendation Systems",
    href: "/ai/ai-recommendation-systems-services",
    title: "AI Recommendation Systems Development Company",
  },
  {
    id: 22,
    image: "/assets/Header/Blockchain/AI/AI agent for smart contract audit",
    href: "/ai/ai-agent-for-smart-contract-audit-services",
    title: "AI agent for smart contract audit Development Company",
  },
  // {
  //   id: 23,
  //   image: "/assets/Header/Blockchain/AI/ethereum",
  //   href: "/ai/ethereum-interop-layer-services",
  //   title: "Ethereum interop layer",
  // },
  // {
  //   id: 24,
  //   image: "/assets/Header/Blockchain/AI/ethCrossChain",
  //   href: "/ai/eth-interop-crosschain-services",
  //   title: "Ethereum Interoperability & Cross-Chain Development Company",
  // },
  {
    id: 25,
    image: "/assets/Header/Blockchain/AI/Decentralized AI Agents",
    href: "/ai/decision-intelligence-platform-services",
    title: "Decision Intelligence Platform Development Company",
  },
  {
    id: 26,
    image:
      "/assets/Header/Blockchain/AI/AI Search & Knowledge System Development",
    href: "/ai/ai-search-knowledge-system-services",
    title: "AI Search & Knowledge System Development Company",
  },
  {
    id: 27,
    image: "/assets/Header/Blockchain/AI/AI Model Training & Fine-Tuning",
    href: "/ai/ai-model-training-finetuning-services",
    title: "AI Model Training & Fine-Tuning Development Company",
  },
  {
    id: 28,
    image: "/assets/Header/Blockchain/AI/Vector Database AI",
    href: "/ai/vector-database-ai-services",
    title: "Vector Database AI Solutions Development Company",
  },
  {
    id: 29,
    image: "/assets/Header/Blockchain/AI/AI Observability",
    href: "/ai/ai-observability-monitoring-services",
    title: "AI Observability & Monitoring Systems Development Company",
  },
  {
    id: 30,
    image: "/assets/Header/Blockchain/AI/GPU-Based AI",
    href: "/ai/gpu-ai-compute-platform-services",
    title: "GPU-Based AI Compute Platform Development Company",
  },
  {
    id: 31,
    image: "/assets/Header/Blockchain/AI/LLM Application",
    href: "/ai/llm-app-development-services",
    title: "LLM Application Development Company",
  },
  {
    id: 32,
    image: "/assets/Header/Blockchain/AI/Decentralized AI Agents",
    href: "/ai/decentralized-ai-agents-services",
    title: "Decentralized AI agents Development Company",
  },
  {
    id: 33,
    image: "/assets/Header/Blockchain/AI/Tokenized AI",
    href: "/ai/tokenized-ai-development-services",
    title: "Tokenized AI Development Company",
  },
  {
    id: 34,
    image: "/assets/Header/Blockchain/AI/AI Farm Management",
    href: "/ai/ai-farm-management-software-development-services",
    title: "AI Farm Management Software Development Company",
  },
  {
    id: 35,
    image: "/assets/Header/Blockchain/AI/AI Crop Disease Detection",
    href: "/ai/ai-crop-disease-detection-software-development-services",
    title: "AI Crop Disease Detection Software Development Company",
  },
  {
    id: 36,
    image: "/assets/Header/Blockchain/AI/AI Crop Yield Prediction",
    href: "/ai/ai-crop-yield-prediction-software-development-services",
    title: "AI Crop Yield Prediction Software Development Company",
  },
];

export const EVM1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/EVM/Token-Bound-Account-Development",
    href: "/evm/token-bound-account-development",
    title: "Token Bound Account Development",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/EVM/Account-Abstraction-ERC-4337-Development-Services",
    href: "/evm/account-abstraction-erc-4337-development",
    title: "Account Abstraction ERC 4337 Development",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/EVM/EIP-7702-dApp-Development-Services",
    href: "/evm/eip-7702-dapp-development",
    title: "EIP-7702 dApp Development Services",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/EVM/ERC-6551-dApp-Development-Services",
    href: "/evm/erc-6551-dapp-development-services",
    title: "ERC-6551 dApp Development Services",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/EVM/ERC-4337-dApp-Development-Services",
    href: "/evm/erc-4337-dapp-development-services",
    title: "ERC-4337 dApp Development Services",
  },
  {
    id: 6,
    image:
      "/assets/Header/Blockchain/EVM/Zero-Knowledge-Proof-Based-dApp-Development-Services",
    href: "/evm/zero-knowledge-proof-based-dapp-development-services",
    title: "Zero Knowledge Proof Based dApp Development Services",
  },
  {
    id: 7,
    image:
      "/assets/Header/Blockchain/EVM/Post-Quantum-Ethereum-Based-dApp-Development-Services",
    href: "/evm/post-quantum-ethereum-based-dapp-development-services",
    title: "Post Quantum Ethereum-Based dApp Development Services",
  },
  {
    id: 8,
    image:
      "/assets/Header/Blockchain/EVM/SLH-Dsa-Based-Post-Quantum-Secure-Blockchain-Development-Services",
    href: "/evm/slh-dsa-based-post-quantum-secure-blockchain-development-services",
    title:
      "SLH DSA (Sphincs+) Based Post-Quantum Blockchain Development Services",
  },
  {
    id: 9,
    image:
      "/assets/Header/Blockchain/EVM/Paymaster-Smart-Contract-Development-Services",
    href: "/evm/paymaster-smart-contract-development-services",
    title: "Paymaster Smart Contract Development Services",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/EVM/ethCrossChain",
    href: "/evm/erc-8004-trustless-ai-agent-development-services",
    title: "ERC 8004 - Trustless AI Agents",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/EVM/eth-intro",
    href: "/evm/eth-interop-crosschain-development-services",
    title: "Ethereum Interoperability & Cross-Chain Development Company",
  },
];

export const NFT1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/NFT/NFT Development Services",
    href: "/nfts/development",
    title: "NFT Development Services",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/NFT/White-Label NFT Marketplace",
    href: "/nfts/white-label-marketplace-development",
    title: "White-Label NFT Marketplace",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace Development",
    href: "/nfts/marketplace-development ",
    title: "NFT Marketplace Development",
  },
  /*  {
        id: 4,
        image: "/assets/Header/Blockchain/NFT/Free NFT Consulting",
        href: "/nfts/free-consulting",
        title: "Free NFT Consulting",
    },*/
  {
    id: 4,
    image: "/assets/Header/Blockchain/NFT/NFT Ecosystem",
    href: "/nfts/ecosystem",
    title: "NFT Ecosystem",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/NFT/Whitelabel Multi chain NFT",
    href: "/nfts/white-label-multi-chain-marketplace-development",
    title: "Whitelabel Multi-Chain NFT",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/NFT/White Label NFT Launchpad",
    href: "/nfts/white-label-launchpad-development",
    title: "White Label NFT Launchpad",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/NFT/NFT Launchpad Development",
    href: "/nfts/launchpad-development",
    title: "NFT Launchpad Development",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/NFT/Cross-Chain NFT Marketplace",
    href: "/nfts/cross-chain-marketplace-development",
    title: "Cross-Chain NFT Marketplace",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/NFT/NFT Exchange Development",
    href: "/nfts/exchange-development",
    title: "NFT Exchange Development",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/NFT/NFT Wallet Development",
    href: "/nfts/wallet-development",
    title: "NFT Wallet Development",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/NFT/NFT minting platform development",
    href: "/nfts/minting-platform-development",
    title: "NFT Minting Platform Development",
  },
  {
    id: 12,
    image: "/assets/Header/Blockchain/NFT/NFT Token Development",
    href: "/nfts/non-fungible-token-development",
    title: "NFT Token Development",
  },
  {
    id: 13,
    image: "/assets/Header/Blockchain/NFT/DAO Enabled NFT Platform",
    href: "/nfts/dao-enabled-platform-development",
    title: "DAO Enabled NFT Platform",
  },
  {
    id: 14,
    image: "/assets/Header/Blockchain/NFT/NFT marketplace with Governance",
    href: "/nfts/marketplace-with-governance-token-development",
    title: "NFT marketplace with Governance",
  },
  {
    id: 15,
    image: "/assets/Header/Blockchain/NFT/Celebrity NFT Marketplace",
    href: "/nfts/celebrity-nft-marketplace-development",
    title: "Celebrity NFT Marketplace",
  },
  {
    id: 16,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace for Music",
    href: "/nfts/music-nft-marketplace-development",
    title: "NFT Marketplace For Music",
  },
  {
    id: 17,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace for Art",
    href: "/nfts/nft-art-marketplace-development",
    title: "NFT Marketplace For Artist",
  },
  {
    id: 18,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace for Sports",
    href: "/nfts/sports-nft-marketplace-development",
    title: "NFT Marketplace For Sports",
  },
  {
    id: 19,
    image: "/assets/Header/Blockchain/NFT/NFT for Physical assets",
    href: "/nfts/physical-assets-marketplace-development",
    title: "NFT For Physical Assets",
  },
  {
    id: 20,
    image: "/assets/Header/Blockchain/NFT/NFT Ticketing Marketplace",
    href: "/nfts/ticketing-marketplace-development",
    title: "NFT Ticketing Marketplace",
  },
];

export const NFT2 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/NFT/SFT Development",
    href: "/nfts/sft-development",
    title: "SFT Development",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/NFT/NFT Studio",
    href: "/nfts/nft-studio",
    title: "NFT Studio",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/NFT/NFT Aggregator Marketplace",
    href: "/nfts/aggregator-marketplace-development",
    title: "NFT Aggregator Marketplace",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace on Ethereum",
    href: "/nfts/ethereum-nft-marketplace-development",
    title: "NFT Marketplace On Ethereum",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace on Polygon",
    href: "/nfts/polygon-nft-marketplace-development",
    title: "NFT Marketplace on Polygon",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace on BSC",
    href: "/nfts/bsc-nft-marketplace-development",
    title: "NFT Marketplace on BSC",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace on Avalanche",
    href: "/nfts/avalanche-nft-marketplace-development",
    title: "NFT Marketplace on Avalanche",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/NFT/NFT Development on Sidechain",
    href: "/nfts/sidechain-nft-marketplace-development",
    title: "NFT Development on Sidechain",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace on Solana",
    href: "/nfts/solana-nft-marketplace-development",
    title: "NFT Marketplace on Solana",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace on Harmony",
    href: "/nfts/harmony-nft-marketplace-development",
    title: "NFT Marketplace on Harmony",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace like SuperRare",
    href: "/nfts/superrare-like-nft-marketplace-development ",
    title: "NFT Marketplace Like SuperRare",
  },
  {
    id: 12,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace like Sudoswap",
    href: "/nfts/sudoswap-like-nft-marketplace-development",
    title: "NFT Marketplace Like Sudoswap",
  },
  {
    id: 13,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace like Sorare",
    href: "/nfts/sorare-like-nft-marketplace-development",
    title: "NFT Marketplace Like Sorare",
  },
  {
    id: 14,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace like OpenSea",
    href: "/nfts/opensea-like-nft-marketplace-development",
    title: "NFT Marketplace Like OpenSea",
  },
  {
    id: 15,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace like Solsea",
    href: "/nfts/solsea-like-nft-marketplace-development",
    title: "NFT Marketplace Like Solsea",
  },
  {
    id: 16,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace like Rarible",
    href: "/nfts/rarible-like-nft-marketplace-development",
    title: "NFT Marketplace Like Rarible",
  },
  {
    id: 17,
    image: "/assets/Header/Blockchain/NFT/NFT Layer 2 Development",
    href: "/nfts/layer-2-development",
    title: "NFT Layer 2 Development",
  },
  {
    id: 18,
    image: "/assets/Header/Blockchain/NFT/Phygital NFT Marketplace",
    href: "/nfts/phygital-marketplace-development",
    title: "Phygital NFT Marketplace",
  },
  {
    id: 19,
    image: "/assets/Header/Blockchain/NFT/P2E NFT Game Development",
    href: "/nfts/p2e-game-development",
    title: "P2E NFT Game Development",
  },
  {
    id: 20,
    image: "/assets/Header/Blockchain/NFT/NFT Marketplace for Real estate",
    href: "/nfts/nft-real-estate-marketplace-development",
    title: "NFT Marketplace For Real estate",
  },
];

export const NFT3 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/NFT/NFT in E-commerce",
    href: "/nfts/nft-in-ecommerce",
    title: "NFT In E-commerce",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/NFT/NFT Gaming Platform",
    href: "/nfts/gaming-platform-development",
    title: "NFT Gaming Platform",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/NFT/DAO Enabled NFT Platform",
    href: "/nfts/dungeon-swap-like-nft-game-development",
    title: "Dungeon Swap Like NFT Game",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/NFT/My Crypto Heros Like NFT Game",
    href: "/nfts/my-crypto-heroes-like-nft-game-development",
    title: "My Crypto Heros Like NFT Game",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/NFT/Zed Run Like NFT Game",
    href: "/nfts/zed-run-like-nft-game-development",
    title: "Zed Run Like NFT Game",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/NFT/Decentraland Like NFT Game",
    href: "/nfts/decentraland-like-nft-game-development",
    title: "Decentraland Like NFT Game",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/NFT/NFT Racing Game",
    href: "/nfts/nft-racing-game-development",
    title: "NFT Racing Game",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/NFT/Revv Racing Like NFT Game",
    href: "/nfts/revv-racing-like-nft-game-development",
    title: "Revv Racing Like NFT Game",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/NFT/NFT Casino Game",
    href: "/nfts/casino-game-development",
    title: "NFT Casino Game",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/NFT/Social Token Development",
    href: "/nfts/nft-social-token-development",
    title: "NFT Social Token Development",
  },

  {
    id: 11,
    image: "/assets/Header/Blockchain/NFT/NFT Staking platform",
    href: "/nfts/staking-platform-development",
    title: "NFT Staking platform",
  },
  {
    id: 12,
    image: "/assets/Header/Blockchain/NFT/NFT Streaming Platform",
    href: "/nfts/streaming-platform-development",
    title: "NFT Streaming Platform",
  },
  {
    id: 13,
    image: "/assets/Header/Blockchain/NFT/NFT Consulting Service",
    href: "/nfts/consulting-service",
    title: "NFT Consulting Service",
  },
  {
    id: 14,
    image: "/assets/Header/Blockchain/NFT/NFT Listing Services",
    href: "/nfts/listing-services",
    title: "NFT Listing Services",
  },
  {
    id: 15,
    image: "/assets/Header/Blockchain/NFT/Fractional NFT Marketplace",
    href: "/nfts/fractional-marketplace-development ",
    title: "Fractional NFT Marketplace",
  },
  {
    id: 16,
    image: "/assets/Header/Blockchain/NFT/Shards NFT Platform",
    href: "/nfts/shards-nft-platform-development",
    title: "Shards NFT Platform",
  },
  {
    id: 17,
    image: "/assets/Header/Blockchain/NFT/White Label P2E NFT Games",
    href: "/nfts/white-label-p2e-game-development",
    title: "White Label P2E NFT Games",
  },
  {
    id: 18,
    image: "/assets/Header/Blockchain/NFT/Web2 to Web3 Game",
    href: "/nfts/web2-to-web3-game-development",
    title: "Web2 To Web3 Game",
  },
  {
    id: 19,
    image: "/assets/Header/Blockchain/NFT/NFT Game Marketplace",
    href: "/nfts/gaming-marketplace-development",
    title: "NFT Game Marketplace",
  },
  {
    id: 20,
    image: "/assets/Header/Blockchain/NFT/Move To Earn NFT Platform",
    href: "/nfts/move-to-earn-platform-development",
    title: "Move To Earn NFT Platform",
  },
];

export const marketing1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/Marketing/NFT Marketing Services",
    href: "/marketing/nft",
    title: "NFT Marketing Services",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/Marketing/NFT Marketplace Marketing Services",
    href: "/marketing/nft-marketplace",
    title: "NFT Marketplace Marketing Services",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/Marketing/NFT Collectibles Marketing",
    href: "/marketing/nft-collectibles",
    title: "NFT Collectibles Marketing",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/Marketing/NFT Game Marketing",
    href: "/marketing/nft-game",
    title: "NFT Game Marketing",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/Marketing/NFT Telegram Marketing",
    href: "/marketing/nft-telegram",
    title: "NFT Telegram Marketing",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/Marketing/Influencer Marketing Agency",
    href: "/marketing/influencer",
    title: "Influencer Marketing Agency",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/Marketing/NFT PRMedia Marketing",
    href: "/marketing/nft-pr-and-media",
    title: "NFT PR And Media Marketing",
  },

  {
    id: 8,
    image: "/assets/Header/Blockchain/Marketing/Discord Marketing",
    href: "/marketing/discord",
    title: "Discord Marketing",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/Marketing/Discord Server Marketing",
    href: "/marketing/discord-server-marketing",
    title: "Discord Server Marketing",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/Marketing/Discord Brand Marketing",
    href: "/marketing/discord-brand",
    title: "Discord Brand Marketing",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/Marketing/Discord Game Marketing",
    href: "/marketing/discord-game",
    title: "Discord Game Marketing",
  },
];

// export const marketing2 = [
//     {
//         id: 11,
//         image: "/assets/Header/Blockchain/Marketing/Discord Game Marketing",
//         href: "/marketing/discord-game",
//         title: "Discord Game Marketing",
//     },
// ];

export const metaverse1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse Avatar Developments",
    href: "/metaverse/metaverse-development-company",
    title: "Metaverse Development Services",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/Metaverse/Metaverse NFT Marketplace Development",
    href: "/metaverse/metaverse-nft-marketplace-development",
    title: "Metaverse NFT Marketplace Development",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse Healthcare Solutions",
    href: "/metaverse/healthcare-solutions-development",
    title: "Metaverse Healthcare Solutions",
  },
  {
    id: 4,
    image:
      "/assets/Header/Blockchain/Metaverse/NFT Metaverse Launchpad Development",
    href: "/metaverse/nft-launchpad-development",
    title: "NFT Metaverse Launchpad Development",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse Event Platform",
    href: "/metaverse/event-platform-development",
    title: "Metaverse Event Platform",
  },
  {
    id: 6,
    image:
      "/assets/Header/Blockchain/Metaverse/Metaverse Platform for Social Interaction",
    href: "/metaverse/social-interaction-platform-development",
    title: "Metaverse Platform for Social Interaction",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse NFT Game Development",
    href: "/metaverse/nft-game-development",
    title: "Metaverse NFT Game Development",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse Art Gallery",
    href: "/metaverse/art-gallery-development",
    title: "Metaverse Art Gallery",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse Avatar Development",
    href: "/metaverse/avatar-development",
    title: "Metaverse Avatar Development",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/Metaverse/Metaverse 3D Space Development",
    href: "/metaverse/3d-space-development",
    title: "Metaverse 3D Space Development",
  },
  {
    id: 11,
    image:
      "/assets/Header/Blockchain/Metaverse/Metaverse Virtual Working Space",
    href: "/metaverse/virtual-working-space-development",
    title: "Metaverse Virtual Working Space",
  },
];

// export const metaverse2 = [
//     {
//         id: 1,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse NFT Game Development",
//         href: "/metaverse/nft-game-development",
//         title: "Metaverse NFT Game Development",
//     },
//     {
//         id: 2,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse Art Gallery",
//         href: "/metaverse/art-gallery-development",
//         title: "Metaverse Art Gallery",
//     },
//     {
//         id: 3,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse Avatar Development",
//         href: "/metaverse/avatar-development",
//         title: "Metaverse Avatar Development",
//     },
//     {
//         id: 4,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse 3D Space Development",
//         href: "/metaverse/3d-space-development",
//         title: "Metaverse 3D Space Development",
//     },
//     {
//         id: 5,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse Virtual Working Space",
//         href: "/metaverse/virtual-working-space-development",
//         title: "Metaverse Virtual Working Space",
//     },
// ];

// export const metaverse3 = [
//     {
//         id: 1,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse Event Platform",
//         href: "/metaverse/event-platform-development",
//         title: "Metaverse Event Platform",
//     },
//     {
//         id: 2,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse Platform for Social Interaction",
//         href: "/metaverse/social-interaction-platform-development",
//         title: "Metaverse Platform for Social Interaction",
//     },
//     {
//         id: 3,
//         image: "/assets/Header/Blockchain/Metaverse/Metaverse Virtual Working Space",
//         href: "/metaverse/virtual-working-space-development",
//         title: "Metaverse Virtual Working Space",
//     },
// ];

export const web3_1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/Web 3.0/Web 3.0 Development",
    href: "/web3/web3-development-services",
    title: "Web 3.0 Development",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/Web 3.0/Web 3.0 dApp Development",
    href: "/web3/dapps-development-services",
    title: "Web3 dApp Development",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/Web 3.0/Web 3.0 Wallet Development",
    href: "/web3/wallet-development",
    title: "Web3 Wallet Development",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/Web 3.0/Web 3.0 Game Development",
    href: "/web3/game-development",
    title: "Web 3.0 Game Development",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/Web 3.0/Web 3.0 Marketing Services",
    href: "/web3/marketing-services",
    title: "Web 3.0 Marketing Services",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/Web 3.0/Metamask like Wallet Development",
    href: "/web3/metamask-like-wallet-development",
    title: "Web3 Metamask like Wallet Development",
  },
  {
    id: 7,
    image:
      "/assets/Header/Blockchain/Web 3.0/Decentralized-Multichain-Wallet-like-Backpack-Evm-Solana",
    href: "/web3/decentralized-multichain-wallet-like-backpack-evm-solana",
    title: "Decentralized Multichain Wallet like Backpack Evm Solana",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/Web 3.0/Meme-Coin-Development",
    href: "/web3/meme-coin-development",
    title: "Meme Coin Development",
  },
  {
    id: 9,
    image:
      "/assets/Header/Blockchain/Web 3.0/AI-ML-Based-Glasses-App-Development",
    href: "/web3/ai-ml-based-glasses-app-development",
    title: "AI/ML Based Glasses App Development",
  },
  {
    id: 10,
    image:
      "/assets/Header/Blockchain/Web 3.0/Multi-Signature-Wallet-Development-Services",
    href: "/web3/multi-signature-wallet-development-services",
    title: "Multi Signature Wallet Development Services",
  },
  {
    id: 11,
    image:
      "/assets/Header/Blockchain/Web 3.0/Farcaster-Based-dApps-Development-Services",
    href: "/web3/farcaster-based-dapps-development",
    title: "Farcaster-Based dApps Development Services",
  },
  {
    id: 12,
    image:
      "/assets/Header/Blockchain/Web 3.0/Cello-Blockchain-Based-dApps-Development-Services",
    href: "/web3/cello-blockchain-based-dapps-development",
    title: "Cello Blockchain-Based dApps Development Services",
  },
];

export const web3_2 = [
  {
    id: 1,
    image:
      "/assets/Header/Blockchain/Web 3.0/Bitcoin-Layer-2-Smart-Contract-Development-Services",
    href: "/web3/bitcoin-layer2-smart-contract-development-services",
    title: "Bitcoin Layer 2 Smart Contract Development Services",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/Web 3.0/Decentralized-Video-Conference-App-Development-with-Solidity",
    href: "/web3/decentralized-video-conference-app-solidity-blockchain",
    title: "Decentralized Video Conference App Development with Solidity",
  },
];

// export const web3_3 = [
//   {
//     id: 1,
//     image: "/assets/Header/Blockchain/Web 3.0/Web 3.0 Development",
//     href: "",
//     title: "Web 3.0 Development",
//   },
// ];

export const defi1 = [
  {
    id: 1,
    image:
      "/assets/Header/Blockchain/DeFi/White-Label Crypto Trading Telegram Bot Solution",
    href: "/defi/white-label-crypto-trading-telegram-bot",
    title: "White-Label Crypto Trading Telegram Bot Solution",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/DeFi/Decentralized Finance (DeFi) Development",
    href: "/defi/defi-development-services",
    title: "DeFi Development Company",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/DeFi/DeFi Platform like Pancakeswap",
    href: "/defi/pancakeswap-like-platform-development",
    title: "DeFi Platform Like Pancakeswap",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/DeFi/DAO Services",
    href: "/defi/dao-development",
    title: "DeFi DAO Services",
  },
  {
    id: 5,
    image:
      "/assets/Header/Blockchain/DeFi/Whitelabel Swap Exchange Development",
    href: "/defi/white-label-swap-exchange-development",
    title: "Whitelabel Swap-Exchange Development",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/DeFi/Pinksale Like Launchpad Development",
    href: "/defi/pinksale-like-launchpad-development",
    title: "Pinksale Like Launchpad Development",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/DeFi/DeFi Staking Platform Development",
    href: "/defi/staking-platform-development",
    title: "DeFi Staking Platform Development",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/DeFi/DeFi Yield Farming Development",
    href: "/defi/yield-farming-development",
    title: "DeFi Yield Farming Development",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/DeFi/DeFi Marketing Services",
    href: "/defi/marketing-services",
    title: "DeFi Marketing Services",
  },
  {
    id: 10,
    image:
      "/assets/Header/Blockchain/DeFi/DeFi Application Development Services",
    href: "/defi/application-development",
    title: "DeFi Application Development Services",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/DeFi/DeFi Token Development Services",
    href: "/defi/token-development",
    title: "DeFi Token Development Services",
  },
  {
    id: 12,
    image:
      "/assets/Header/Blockchain/DeFi/DeFi Protocol Development like yearn finance",
    href: "/defi/protocol-like-yearn-finance-development",
    title: "DeFi Protocol Development like yearn finance",
  },
];

export const defi2 = [
  {
    id: 1,
    image:
      "/assets/Header/Blockchain/DeFi/Limit-Order-Automated-Market-Maker-Trading-Platform-Development-Services",
    href: "/defi/limit-order-automated-market-maker-trading-platform-development-services",
    title: "Limit Order Automated Market Maker Development Services",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/DeFi/Multichain-DEX-Development-Services",
    href: "/defi/multichain-dex-development-services",
    title: "Multichain DEX Development Services",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/DeFi/DeFi Wallet Development Solution",
    href: "/defi/wallet-development",
    title: "DeFi Wallet Development Solution",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/DeFi/DeFi Synthetic Assets Development",
    href: "/defi/synthetic-assets-development",
    title: "DeFi Synthetic Assets Development",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/DeFi/DeFi crowdfunding platform",
    href: "/defi/crowd-funding-platform-development",
    title: "DeFi Crowdfunding Platform",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/DeFi/DeFi Real estate platform",
    href: "/defi/real-estate-platform-development",
    title: "DeFi Real-Estate Platform",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/DeFi/DeFi Exchange Development Solution",
    href: "/defi/dex-development",
    title: "DeFi Exchange Development Solution",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/DeFi/DeFi Platform Like Uniswap",
    href: "/defi/uniswap-like-platform-development",
    title: "DeFi Platform Like Uniswap",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/DeFi/telegram-trading-bot-development",
    href: "/defi/telegram-trading-bot-development",
    title: "Telegram Trading Bot Development",
  },
  {
    id: 10,
    image:
      "/assets/Header/Blockchain/DeFi/smart-wallet-account-development-services",
    href: "/defi/smart-wallet-account-development-services",
    title: "Smart Wallet Account Development Services",
  },
  {
    id: 11,
    image:
      "/assets/Header/Blockchain/DeFi/analytics-dashboard-development-services",
    href: "/defi/analytics-dashboard-development-services",
    title: "Analytics Dashboard Development Services",
  },
  {
    id: 12,
    image:
      "/assets/Header/Blockchain/DeFi/On-Chain-Trading-App-Development-Services",
    href: "/defi/on-chain-trading-app-development-services",
    title: "On-Chain Trading App Development Services",
  },
];

export const defi3 = [
  {
    id: 1,
    image:
      "/assets/Header/Blockchain/DeFi/Real-World-Asset-Tokenization-dApp-Development",
    href: "/defi/real-world-asset-tokenization-platform-development",
    title: "Real World Asset Tokenization dApp Development Services",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/DeFi/Lending-and-Borrowing-Protocol-Development",
    href: "/defi/lending-and-borrowing-protocol-development",
    title: "Lending and Borrowing Protocol Development",
  },
  {
    id: 3,
    image:
      "/assets/Header/Blockchain/DeFi/Cross-Chain-Swap-Protocol-Development",
    href: "/defi/cross-chain-swap-protocol-development",
    title: "Cross Chain Swap Protocol Development Services",
  },
];

export const ico1 = [
  {
    id: 0,
    title: "1. ICO",
    textClr: "text-[#410ead]",
    // href: "/",
  },
  {
    id: 1,
    image: "/assets/Header/Blockchain/ICO STO IDO/ICO Development",
    href: "/ico/ico-development",
    title: "ICO Development",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/ICO STO IDO/ICO Marketing",
    href: "/ico/marketing",
    title: "ICO Marketing",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/ICO STO IDO/ICO Community Marketing",
    href: "/ico/community-marketing",
    title: "ICO Community Marketing",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/ICO STO IDO/ICO Telegram Marketing",
    href: "/ico/telegram-marketing",
    title: "ICO Telegram Marketing",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/ICO STO IDO/ICO Influencer Marketing",
    href: "/ico/influencer-marketing",
    title: "ICO Influencer Marketing",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/ICO STO IDO/IEO Development",
    href: "/ico/ieo-development",
    title: "IEO Development",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/ICO STO IDO/ETO Development",
    href: "/ico/eto-development",
    title: "ETO Development",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/ICO STO IDO/Crowdfunding Platform",
    href: "/ico/crowdfunding-platform",
    title: "Crowdfunding Platform",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/ICO STO IDO/ICO Youtube Influencer",
    href: "/ico/youtube-influencer",
    title: "ICO Youtube Influencer",
  },
];

export const sto1 = [
  {
    id: 0,
    title: "2. STO",
    // href: "/",
    textClr: "text-[#410ead]",
  },
  {
    id: 1,
    image: "/assets/Header/Blockchain/ICO STO IDO/STO Development",
    href: "/sto/development",
    title: "STO Development",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/ICO STO IDO/STO Marketing",
    href: "/sto/marketing",
    title: "STO Marketing",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/ICO STO IDO/STO Smart Contracts",
    href: "/sto/smart-contract-development",
    title: "STO Smart Contracts",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/ICO STO IDO/Real Estate Tokenization",
    href: "/sto/real-estate-tokenization",
    title: "STO Real E-state Tokenization",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/ICO STO IDO/Asset Tokenization",
    href: "/sto/asset-tokenization",
    title: "STO Asset Tokenization",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/ICO STO IDO/Art Tokenization",
    href: "/sto/art-tokenization",
    title: "STO Art Tokenization",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/ICO STO IDO/Tokenization Platform",
    href: "/sto/tokenization-platform-development",
    title: "STO Tokenization Platform",
  },
];

export const ido1 = [
  {
    id: 0,
    // href: "",
    title: "3. IDO/Launchpad",
    textClr: "text-[#410ead]",
  },
  {
    id: 1,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Development",
    href: "/ido/development",
    title: "IDO Development",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Marketing",
    href: "/ido/marketing",
    title: "IDO Marketing",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/ICO STO IDO/White Label IDO Launchpad",
    href: "/ido/white-label-ido-launchpad",
    title: "White Label IDO Launchpad",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Token Launchpad",
    href: "/ido/ido-token-launchpad-development",
    title: "IDO Token Launchpad",
  },
  {
    id: 5,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Launchpad On BSC",
    href: "/ido/ido-launchpad-development-on-bsc",
    title: "IDO Launchpad On BSC",
  },
  {
    id: 6,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Launchpad On Ethereum",
    href: "/ido/ido-launchpad-development-on-ethereum",
    title: "IDO Launchpad On Ethereum",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Launchpad In Multichain",
    href: "/ido/ido-launchpad-development-on-multichain",
    title: "IDO Launchpad In Multichain",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/ICO STO IDO/IDO Launchpad On Polygon",
    href: "/ido/ido-launchpad-development-on-polygon",
    title: "IDO Launchpad On Polygon",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/ICO STO IDO/IGO Launchpad Development",
    href: "/ido/igo-launchpad-development",
    title: "IGO Launchpad Development",
  },
];

export const crypto1 = [
  {
    id: 1,
    image:
      "/assets/Header/Blockchain/Crypto/Crypto Casino Game Development Company",
    href: "/crypto/casino-game-development",
    title: "Crypto Casino Game Development Company",
  },
  {
    id: 2,
    image: "/assets/Header/Blockchain/Crypto/Cryptocurrency Development",
    href: "/crypto/cryptocurrency-development",
    title: "Cryptocurrency Development",
  },
  {
    id: 3,
    image: "/assets/Header/Blockchain/Crypto/Stable Coin Development",
    href: "/crypto/stable-coin-development",
    title: "Stable Coin Development",
  },
  {
    id: 4,
    image: "/assets/Header/Blockchain/Crypto/White label Crypto Exchange",
    href: "/crypto/white-label-crypto-exchange",
    title: "White Label Crypto Exchange",
  },
  {
    id: 5,
    image:
      "/assets/Header/Blockchain/Crypto/Cryptocurrency Exchange Development",
    href: "/crypto/cryptocurrency-exchange-development",
    title: "Cryptocurrency Exchange Development",
  },
  {
    id: 6,
    image:
      "/assets/Header/Blockchain/Crypto/Decentralized Exchange Development",
    href: "/crypto/decentralized-exchange-development",
    title: "Decentralized Exchange Development",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/Crypto/P2P Exchange Development",
    href: "/crypto/p2p-exchange-development",
    title: "Crypto P2P Exchange Development",
  },
  {
    id: 8,
    image: "/assets/Header/Blockchain/Crypto/Wallet Development",
    href: "/crypto/crypto-wallet-development",
    title: "Crypto Wallet Development",
  },
  {
    id: 9,
    image: "/assets/Header/Blockchain/Crypto/Crypto-Payment Development",
    href: "/crypto/crypto-payment-development",
    title: "Crypto Payment Development",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/Crypto/Exchange Listing Services",
    href: "/crypto/crypto-exchange-listing-services",
    title: "Crypto Exchange Listing Services",
  },
  {
    id: 11,
    image:
      "/assets/Header/Blockchain/Crypto/Cryptocurrency Exchange Like Wazirx",
    href: "/crypto/cryptocurrency-exchange-like-wazirx",
    title: "Cryptocurrency Exchange Like Wazirx",
  },
];

export const crypto2 = [
  {
    id: 1,
    image:
      "/assets/Header/Blockchain/Crypto/Cryptocurrency Exchange Like Binance",
    href: "/crypto/cryptocurrency-exchange-like-binance",
    title: "Cryptocurrency Exchange Like Binance",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/Crypto/Cryptocurrency Exchange Like Coinbase",
    href: "/crypto/cryptocurrency-exchange-like-coinbase",
    title: "Cryptocurrency Exchange Like Coinbase",
  },
];

// export const crypto3 = [
//   {
//     id: 1,
//     image: "/assets/Header/Blockchain/Crypto/Cryptocurrency Exchange Marketing",
//     href: "/crypto/cryptocurrency-exchange-like-binance",
//     title: "Cryptocurrency Exchange Marketing",
//   },
// ];

export const blockchain1 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/Blockchain Sub/Blockchain Development",
    href: "/blockchain/blockchain-development-services",
    title: "Blockchain Development Services",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/White Label Blockchain Solutions",
    href: "/blockchain/white-label-blockchain-development-services",
    title: "White Label Blockchain Solutions",
  },
  {
    id: 3,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Custom Blockchain On Avalanche",
    href: "/blockchain/custom-blockchain-development-on-avalanche",
    title: "Custom Blockchain On Avalanche",
  },
  {
    id: 4,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Custom Blockchain On Polygon",
    href: "/blockchain/custom-blockchain-development-on-polygon",
    title: "Custom Blockchain On Polygon",
  },
  {
    id: 5,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Solana Blockchain Development",
    href: "/blockchain/solana-blockchain-development",
    title: "Solana Blockchain Development",
  },
  {
    id: 6,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Blockchain  Web3.0 Consulting",
    href: "/blockchain/blockchain-and-web3-consulting",
    title: "Blockchain and Web 3.0 Consulting",
  },
  {
    id: 7,
    image: "/assets/Header/Blockchain/Blockchain Sub/Proof Of Reserve",
    href: "/blockchain/blockchain-proof-of-reserve",
    title: "Blockchain Proof of Reserve",
  },
  {
    id: 8,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Carbon Credits Development",
    href: "/blockchain/carbon-credits-development",
    title: "Carbon Credits Development",
  },
  ,
  {
    id: 9,
    image: "/assets/Header/Blockchain/Blockchain Sub/DApps Development",
    href: "/blockchain/blockchain-dapps-development",
    title: "Blockchain dApps Development",
  },
  {
    id: 10,
    image: "/assets/Header/Blockchain/Blockchain Sub/P2P Lending Software",
    href: "/blockchain/blockchain-p2p-lending-software",
    title: "Blockchain P2P Lending Software",
  },
  {
    id: 11,
    image: "/assets/Header/Blockchain/Blockchain Sub/Blockchain for Finance",
    href: "/blockchain/blockchain-for-finance",
    title: "Blockchain For Finance",
  },
];

export const blockchain2 = [
  {
    id: 1,
    image: "/assets/Header/Blockchain/Blockchain Sub/Protocol Implementation",
    href: "/blockchain/blockchain-protocol-implementation",
    title: "Blockchain Protocol Implementation",
  },
  {
    id: 2,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Blockchain for Pharma Industry",
    href: "/blockchain/blockchain-for-pharma-industry",
    title: "Blockchain For Pharma Industry",
  },
  {
    id: 3,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/EVM Compatible Blockchain and Service",
    href: "/blockchain/evm-compatible-blockchain-and-service",
    title: "EVM Compatible Blockchain and Service",
  },
  {
    id: 4,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Smart Contract Development",
    href: "/blockchain/smart-contract-development",
    title: "Smart Contract Development",
  },
  {
    id: 5,
    image:
      "/assets/Header/Blockchain/Blockchain Sub/Quantum-Blockchain-Development",
    href: "/blockchain/quantum-blockchain-development-services",
    title: "Quantum Blockchain Development",
  },
];

// export const blockchain3 = [
//   {
//     id: 1,
//     image: "/assets/Header/Blockchain/Blockchain Sub/Blockchain for Finance",
//     href: "",
//     title: "Blockchain for Finance",
//   },
// ];
